<template>
  <div class="catalog-cart">
    <div 
      class="catalog-cart__body">
      <cart editable />

      <actions-button
        appearance="primary"
        class="catalog-cart__cta"
        :href="{name: 'sayl-oat-checkout.review'}"
        icon-post="arrow-right">{{ $t('sayl-oat.cart_primary_action') }}</actions-button>
    </div>
  </div>
</template>

<script>
import Cart from '@/components/checkout/cart'

export default {
  name: 'CatalogCart',

  components: {
    Cart
  },
}
</script>
